export const localRouter_meun_yq = [ 
    //域内招商 园区招商全部楼宇 全部企业 为新增页面 默认为true
    {
        code: "A1",
        switch: true,
        name: "域内招商",
        oldtext: "域内招商",
        type: "ynzs",
        url: "/allBuildings",
        open: true,
        icontype: "el-icon-menu",
        children: [{
                code: "A-QBLY",
                switch: true,
                name: "",
                oldtext: "全部楼宇",
                url: "/allBuildings"
            },
            {
                code: "A-QBQY",
                switch: true,
                name: "",
                oldtext: "全部企业",
                url: "/allEnterprises"
            },
            // {code:"B-CYYQK",switch:false,name:"",oldtext:"全部园区",url:"/industrialpark"},
            // {code:"A-ABLY",switch:false,name:"",oldtext:"全部园区",url:"/allParks"},、、园区没有列表没有数据
            {
                code: "A-ZSDT",
                switch: false,
                name: "",
                oldtext: "招商地图",
                url: "/enterprise-mapsearch"
            },
        ]
    },
    //域外招商
    {
        code: "A",
        switch: false,
        name: "域外招商",
        oldtext: "域外招商",
        type: "cyzs",
        url: "/enterpriseList?type=9&Pt=1",
        open: true,
        icontype: "el-icon-menu",
        children: [{
                code: "A-LTQY",
                switch: true,
                name: "",
                oldtext: "龙头企业库",
                url: "/enterpriseList?type=9&Pt=1"
            },
            {
                code: "A-KCQY",
                switch: true,
                name: "",
                oldtext: "科创企业库",
                url: "/enterpriseList?type=2&Pt=2"
            },
            {
                code: "A-QBNZQY",
                switch: false,
                name: "",
                oldtext: "全部内资企业库",
                url: "/totalEnterprises"
            },
            {
                code: "A-JWSSQY",
                switch: false,
                name: "",
                oldtext: "境外上市企业库",
                url: "/foreignEnterprises"
            },
            {
                code: "A-WZQY",
                switch: true,
                name: "",
                oldtext: "外资企业库",
                url: "/forcapEnterprise"
            },
            {
                code: "A-TZJG",
                switch: false,
                name: "",
                oldtext: "投资机构",
                url: "/investment-institutions"
            },
            {
                code: "A-KYJG",
                switch: false,
                name: "",
                oldtext: "科研机构",
                url: "/innovative-resources"
            },
        ],
    },
    //产业研究
    {
        code: "B",
        switch: false,
        name: "产业研究",
        oldtext: "产业研究",
        url: "/allchain",
        open: true,
        icontype: "el-icon-s-order",
        children: [{
                code: "B-QGTP",
                switch: false,
                name: "",
                oldtext: "全国图谱",
                url: "/allchain"
            },
            {
                code: "B-DDTP",
                switch: false,
                name: "",
                oldtext: "当地图谱",
                url: "/localChainList"
            },
            {
                code: "B-TZXMK",
                switch: false,
                name: "",
                oldtext: "投资项目库",
                url: "invest"
            },
            {
                code: "B-NDXMK",
                switch: false,
                name: "",
                oldtext: "拿地项目库",
                url: "land"
            },
            {
                code: "B-DTJC",
                switch: false,
                name: "",
                oldtext: "动态监测",
                url: "/investdynamic"
            },
            {
                code: "B-CYZC",
                switch: false,
                name: "",
                oldtext: "政策库",
                url: "/policylibrary"
            },
            {
                code: "T-CXQYRZ",
                switch: true,
                name: "",
                oldtext: "企业投资动态报告",
                url: "freeReport",
                reportId: 10006, 
            },
            {code:"T-CXQYRZ",switch:true,name:"",oldtext:"产业投资动态跟踪月报",url:"reportList",reportId:10055},
        ]
    },
    //关系计算器
    {
        code: "E",
        switch: false,
        name: "",
        oldtext: "关系计算器",
        url: "/enterprisesCityRelation",
        open: true,
        morebtn: false,
        icontype: "el-icon-s-platform",
        children: [{
                code: "E-QY－CSGXJSQ",
                switch: false,
                name: "",
                oldtext: "企业-城市 关系计算器",
                url: "/enterprisesCityRelation",
                newType: "HOT",
            },
            {
                code: "E-GXJSQ",
                switch: false,
                name: "",
                oldtext: "企业-企业 关系计算器",
                url: "/relationalcalculator"
            },

            {
                code: "E-ZZDT",
                switch: false,
                name: "",
                oldtext: "作战地图",
                url: "/targetMap",
            },
            {
                code: "E-WDGXW",
                switch: false,
                name: "",
                oldtext: "我的关系网",
                url: "/userrelational"
            },
        ]
    },
    // //智能推荐 园区招商智能推荐为新增页面 默认为true
    // {code:"D",switch:false,name:"智能推荐",oldtext:"智能推荐",url:"/industrial-opportunities",open:true,icontype:"el-icon-s-opportunity",children:[
    // {code:"B-QGTP",switch:true,name:"",oldtext:"楼宇招商线索",url:"/industrial-opportunities"},
    // {code:"B-DDTP",switch:true,name:"",oldtext:"企业招商线索",url:"/localChainList"},]},
    // //园区大数据
    // {code:"D",switch:false,name:"园区大数据",oldtext:"园区大数据",url:"/industrial-opportunities",open:true,icontype:"el-icon-s-opportunity",children:[
    // {code:"B-QGTP",switch:false,name:"",oldtext:"待定",url:"/industrial-opportunities"}, ]},
    //工作台
    {
        code: "E",
        switch: false,
        name: "工作台",
        oldtext: "工作台",
        url: "/workbench",
        open: true,
        icontype: "el-icon-s-cooperation",
        children: [{
                code: "E-MBQY",
                switch: false,
                name: "",
                oldtext: "目标企业",
                url: "/focusenterprises"
            }, //parkFocusEnterprises
            {
                    code: "E-DBQY",
                    switch: true,
                    name: "",
                    oldtext: "企业对比",
                    url: "/enterprise-compare",
                    newType:'NEW',
                },
            {
                code: "E-TJFX",
                switch: false,
                name: "",
                oldtext: "统计分析",
                url: "/statisticalAnalysis"
            },
            {
                code: "E-XMGL",
                switch: false,
                name: "",
                oldtext: "项目管理",
                url: "/projectmanagement"
            },
            {
                code: "E-GJJL",
                switch: false,
                name: "",
                oldtext: "跟进记录",
                url: "/followuprecord"
            },
            {
                code: "E-DBJL",
                switch: false,
                name: "",
                oldtext: "待办记录",
                url: "/todolist"
            },
        ]
    },
    //个人中心
    {
        code: "F",
        switch: false,
        name: "个人中心",
        oldtext: "个人中心",
        url: "/baseInformation",
        open: true,
        openicon: true,
        icontype: "el-icon-s-custom",
        children: [{
                code: "F-JBZL",
                switch: false,
                name: "",
                oldtext: "基本资料",
                url: "/baseInformation"
            },
            {
                code: "F-MMXG",
                switch: false,
                name: "",
                oldtext: "密码修改",
                url: "/editPassword"
            },
            // {code:"F-FWSC",switch:false,name:"",oldtext:"服务手册",url:"/servicebook"},
            {
                code: "F-TCZH",
                switch: false,
                name: "",
                oldtext: "退出账号",
                url: "loginout"
            },
        ]
    },
]